/* SwitchToIotDeviceExplorerComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const SwitchToDeviceExplorerRenderer = require("./SwitchToIotDeviceExplorerRenderer");

/**
 * This is a hack view component to switch view to Device Explorer
 */
class SwitchToDeviceExplorerComponent extends EventEmitter {
    constructor(logger, gameEditor, steveIo, EditorSectionMgr) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._fileFactory = steveIo.fileFactory;
        this._editorComponent = EditorSectionMgr;
        this._renderer = new SwitchToDeviceExplorerRenderer(this);
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    closeAllEditors() {
        this._editorComponent._editorLayout.closeAllEditors();
    }

    shutdown() {
        return this._renderer.shutdown().then(() => {
            this._logger = undefined;
            this._fileFactory = undefined;
            this._editorComponent = undefined;
            this._gameEditor = undefined;
            this._renderer = undefined;
            return Promise.resolve();
        });
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }
}
module.exports = SwitchToDeviceExplorerComponent;

SwitchToDeviceExplorerComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.io",
    "EditorSection.EditorSectionMgr",
];

SwitchToDeviceExplorerComponent.$displayDetails = {
    type: "View",
    name: "IoT Device Explorer",
    icon: "configdrift.iot_devices_flat",
    title: "IoT Device Explorer",
    shown: true,
    order: 2,
};
